export class Contact {
  fullName: string;
  email: string;
  phone?: string;
  title?: string;

  constructor(obj: Partial<Contact>) {
    Object.assign(this, obj);
  }
}

export class Company {
  id: number;
  name: string;
}

export class Employee {
  firstName = '';
  middleName = '';
  lastName = '';
  get name(): string {
    return this.firstName + ' ' + this.lastName;
  }
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zip: string;
  title = '';
  contactType = '';
  isKeyContact = false;
  email = '';
  phone = '';
  previousExperience: boolean;
  previousEmployer: string;
  isActive = true;
  dealer?: Dealer;
  id?: string;
  daysBeforeRenewal: number;

  constructor(obj: Partial<Employee>) {
    Object.assign(this, obj);
  }

}

export class Dealer {

  id: number;
  name: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  country: string;
  zip: string;
  phone: string;
  phoneExt: string;
  email: string;
  website: string;
  fax: string;
  contact: Contact = new Contact({});
  distributor: Distributor;
  employees: Array<Employee>;

  sponsoredDate: Date;
  certificateIssueDate: Date;
  proStatus: string;
  daysBeforeRenewal: number;

  constructor(obj: Partial<Dealer>) {
    Object.assign(this, obj);
  }

}

export class SelectableDealer {
  dealer: Dealer;
  isSelected: boolean;
}

export class Course {
  dealer: string;
  courseName: string;
  courseCompletionDate: Date;
  courseExpiration: Date;
  courseStatus: boolean;
  employeeName?: string;

  constructor(obj: Partial<Course>) {
    Object.assign(this, obj);
  }
}

export class CourseEnrollment {
    courseName: string;
    certificateEnrollmentDate: Date;
  constructor(obj: Partial<CourseEnrollment>) {
    Object.assign(this, obj);
  }

}

export class AvailableCourse {
    course: Course;
    selected: boolean;
}

export class Distributor {
  name: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zip: string;
  phone: string;
  email: string;
  website: string;
  fax: string;
  vertical: string;
  billToCode: string;
  manufacturerRep: string;
  contact: Contact;
  daysBeforeRenewal: number;
  employees: Array<Employee>;

  constructor(obj: Partial<Distributor>) {
    Object.assign(this, obj);
  }

}

export class Meeting {
  name: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zip: string;
  requestedDate: Date;
  foodProvided: Boolean;
  comments: string;
  invitees: Array<Dealer> = [];

  constructor(obj: Partial<Meeting>) {
    Object.assign(this, obj);
  }
}

export class UpdateRequest {
  comments: string;
}



// WEBPACK FOOTER //
// ./src/app/distributor/model/distributor.model.ts